<template>
  <loader v-if="loading"></loader>
  <load-page-layout
    v-else
    :breadcrumbs="breadcrumbs"
    :cancel-button="true"
    :remove-button="$route.params.id !== 'new' && instance.permissions.delete"
    :edit-button="!editing && instance.permissions.update"
    :save-button="editing"
    remove-confirm-message="Vuoi veramente eliminare questo tag?"
    @cancel="cancel"
    @remove="remove"
    @edit="edit"
    @save="save">
    <tag-editor
      :value="instance"
      :errors="errors"
      :disabled="!editing"
      @input="instance = $event"
    />
    <debug-panel slot="debug">{{ instance }}</debug-panel>
  </load-page-layout>
</template>
<script>
import TagService from 'app/services/TagService';
import LoadPageMixin from 'vue-core/mixins/LoadPageMixin';

export default {
  mixins: [ LoadPageMixin ],

  created() {
    this.service = TagService;
  },

  computed: {
    breadcrumbs() {
      if (!this.instance) {
        return [];
      }

      return [
        {
          label: 'Home',
          link: '/protected'
        },
        {
          label: 'Tag',
          link: '/protected/tags'
        },
        {
          label: this.$route.params.id === 'new'
              ? '<Nuovo>'
              : (this.instance && this.instance.label || '<Tag>')
        }
      ];
    },
  },

  methods: {
    cancel() {
      if (!this.instance.id || !this.editing) {
        this.$router.push({
          name: 'Tags'
        });
      } else {
        this.unedit();
      }
    },

    onRemoveSuccess({ statusCode, data}) {
      this.$router.push({
        name: 'Tags'
      });
    },
  }
};
</script>
